// koopbatanganloanmanagement/frontendadminr/src/pages/Home/activityData.ts
import activityOne from '../../assets/activity-1.png';
import activityTwo from '../../assets/activity-2.png';
import activityThree from '../../assets/activity-3.png';

import anniv1 from '../../assets/act/anniv/anniv1.jpg';
import anniv2 from '../../assets/act/anniv/anniv2.jpg';
import anniv3 from '../../assets/act/anniv/anniv3.jpg';
import anniv4 from '../../assets/act/anniv/anniv4.jpg';
import anniv5 from '../../assets/act/anniv/anniv5.jpg';
import anniv6 from '../../assets/act/anniv/anniv6.jpg';

// Roadshow images
import road1 from '../../assets/act/road/road1.jpg';
import road2 from '../../assets/act/road/road2.jpg';
import road3 from '../../assets/act/road/road3.jpg';
import road4 from '../../assets/act/road/road4.jpg';
import road5 from '../../assets/act/road/road5.jpg';
import road6 from '../../assets/act/road/road6.jpg';
import road7 from '../../assets/act/road/road7.jpg';
import road8 from '../../assets/act/road/road8.jpg';
import road9 from '../../assets/act/road/road9.jpg';
import road10 from '../../assets/act/road/road10.jpg';
import road11 from '../../assets/act/road/road11.jpg';
import road12 from '../../assets/act/road/road12.jpg';
import road13 from '../../assets/act/road/road13.jpg';
import road14 from '../../assets/act/road/road14.jpg';
import road15 from '../../assets/act/road/road15.jpg';
import road16 from '../../assets/act/road/road16.jpg';
import road17 from '../../assets/act/road/road17.jpg';
import road18 from '../../assets/act/road/road18.jpg';
import road19 from '../../assets/act/road/road19.jpg';
import road20 from '../../assets/act/road/road20.jpg';
import road21 from '../../assets/act/road/road21.jpg';
import road22 from '../../assets/act/road/road22.jpg';
import road23 from '../../assets/act/road/road23.jpg';
import road24 from '../../assets/act/road/road24.jpg';
import road25 from '../../assets/act/road/road25.jpg';
import road26 from '../../assets/act/road/road26.jpg';
import road27 from '../../assets/act/road/road27.jpg';
import road28 from '../../assets/act/road/road28.jpg';
import road29 from '../../assets/act/road/road29.jpg';
import road30 from '../../assets/act/road/road30.jpg';
import road31 from '../../assets/act/road/road31.jpg';
import road32 from '../../assets/act/road/road32.jpg';
import road33 from '../../assets/act/road/road33.jpg';

// Seminar images
import seminar1 from '../../assets/act/seminar/seminar-1.jpg';
import seminar2 from '../../assets/act/seminar/seminar-2.jpg';
import seminar3 from '../../assets/act/seminar/seminar-3.jpg';
import seminar4 from '../../assets/act/seminar/seminar-4.jpg';
import seminar5 from '../../assets/act/seminar/seminar-5.jpg';
import seminar6 from '../../assets/act/seminar/seminar-6.jpg';
import seminar7 from '../../assets/act/seminar/seminar-7.jpg';
import seminar8 from '../../assets/act/seminar/seminar-8.jpg';
import seminar9 from '../../assets/act/seminar/seminar-9.jpg';
import seminar10 from '../../assets/act/seminar/seminar-10.jpg';

import bisness1 from '../../assets/act/bisness/bisness1.jpg';
import bisness2 from '../../assets/act/bisness/bisness2.jpg';
import bisness3 from '../../assets/act/bisness/bisness3.jpg';
import bisness4 from '../../assets/act/bisness/bisness4.jpg';
import bisness5 from '../../assets/act/bisness/bisness5.jpg';
import bisness6 from '../../assets/act/bisness/bisness6.jpg';
import bisness7 from '../../assets/act/bisness/bisness7.jpg';
import bisness8 from '../../assets/act/bisness/bisness8.jpg';
import bisness9 from '../../assets/act/bisness/bisness9.jpg';
import bisness10 from '../../assets/act/bisness/bisness10.jpg';
import bisness11 from '../../assets/act/bisness/bisness11.jpg';
import bisness12 from '../../assets/act/bisness/bisness12.jpg';
import bisness13 from '../../assets/act/bisness/bisness13.jpg';
import bisness14 from '../../assets/act/bisness/bisness14.jpg';
import bisness15 from '../../assets/act/bisness/bisness15.jpg';
import bisness16 from '../../assets/act/bisness/bisness16.jpg';
import bisness17 from '../../assets/act/bisness/bisness17.jpg';
import bisness18 from '../../assets/act/bisness/bisness18.jpg';
import bisness19 from '../../assets/act/bisness/bisness19.jpg';
import bisness20 from '../../assets/act/bisness/bisness20.jpg';


export const activities = [
    {
        id: 1,
        type: 'EVENT',
        image: activityOne,
        title: '20th funding anniversary',
        date: '',
        desc: 'A formal seminar held in Tagaytay aimed at deepening cooperative leadership, fostering strategic alignment, and encouraging professional knowledge-sharing among members.',
    },
    {
        id: 2,
        type: 'TRAINING',
        image: activityTwo,
        title: 'Roadshow Membership Cooperative refresher Course',
        date: '',
        desc: 'A traveling refresher course designed to reintroduce and reinforce cooperative principles, responsibilities, and member engagement across various locations.',
    },
    {
        id: 3,
        type: 'SEMINAR',
        image: activityThree,
        title: '2025 Tagaytay Seminar',
        date: '',
        desc: 'A milestone celebration marking twenty years of continuous funding support, highlighting the cooperative’s dedication to growth, sustainability, and community empowerment.',
    },
    {
        id: 4,
        type: 'DEMO',
        image: bisness1,
        title: 'KOOP Bisness Product Demo',
        date: '',
        desc: 'Product Demonstration of KOOPs new products line for sale.',
    },
];

export const eventGroups = [


    {
        id: 1,
        photos: [
            {
                src: anniv1,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: anniv1, width: 400, height: 300 },
                ],
            },
            {
                src: anniv2,
                width: 600,
                height: 900,
                srcSet: [
                    { src: anniv2, width: 400, height: 300 },
                ],
            },
            {
                src: anniv3,
                width: 700,
                height: 900,
                srcSet: [
                    { src: anniv3, width: 400, height: 300 },
                ],
            },
            {
                src: anniv4,
                width: 700,
                height: 900,
                srcSet: [
                    { src: anniv4, width: 400, height: 300 },
                ],
            },
            {
                src: anniv5,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: anniv5, width: 400, height: 300 },
                ],
            },
            {
                src: anniv6,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: anniv6, width: 400, height: 300 },
                ],
            },
        ],
    },
    {
        id: 2,
        photos: [
            {
                src: road1,
                width: 700,
                height: 900,
                srcSet: [
                    { src: road1, width: 800, height: 450 },
                ],
            },
            {
                src: road2,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road2, width: 800, height: 450 },
                ],
            },
            {
                src: road3,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road3, width: 800, height: 450 },
                ],
            },
            {
                src: road4,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road4, width: 800, height: 450 },
                ],
            },
            {
                src: road5,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road5, width: 800, height: 450 },
                ],
            },
            {
                src: road6,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road6, width: 800, height: 450 },
                ],
            },
            {
                src: road7,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road7, width: 800, height: 450 },
                ],
            },
            {
                src: road8,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road8, width: 800, height: 450 },
                ],
            },
            {
                src: road9,
                width: 700,
                height: 900,
                srcSet: [
                    { src: road9, width: 800, height: 450 },
                ],
            },
            {
                src: road10,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road10, width: 800, height: 450 },
                ],
            },
            {
                src: road11,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road11, width: 800, height: 450 },
                ],
            },
            {
                src: road12,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road12, width: 800, height: 450 },
                ],
            },
            {
                src: road13,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road13, width: 800, height: 450 },
                ],
            },
            {
                src: road14,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road14, width: 800, height: 450 },
                ],
            },
            {
                src: road15,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road15, width: 800, height: 450 },
                ],
            },
            {
                src: road16,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road16, width: 800, height: 450 },
                ],
            },
            {
                src: road17,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road17, width: 800, height: 450 },
                ],
            },
            {
                src: road18,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road18, width: 800, height: 450 },
                ],
            },
            {
                src: road19,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road19, width: 800, height: 450 },
                ],
            },
            {
                src: road20,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road20, width: 800, height: 450 },
                ],
            },
            {
                src: road21,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road21, width: 800, height: 450 },
                ],
            },
            {
                src: road22,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road22, width: 800, height: 450 },
                ],
            },
            {
                src: road23,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road23, width: 800, height: 450 },
                ],
            },
            {
                src: road24,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road24, width: 800, height: 450 },
                ],
            },
            {
                src: road25,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road25, width: 800, height: 450 },
                ],
            },
            {
                src: road26,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road26, width: 800, height: 450 },
                ],
            },
            {
                src: road27,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road27, width: 800, height: 450 },
                ],
            },
            {
                src: road28,
                width: 700,
                height: 900,
                srcSet: [
                    { src: road28, width: 800, height: 450 },
                ],
            },
            {
                src: road29,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road29, width: 800, height: 450 },
                ],
            },
            {
                src: road30,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road30, width: 800, height: 450 },
                ],
            },
            {
                src: road31,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road31, width: 800, height: 450 },
                ],
            },
            {
                src: road32,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road32, width: 800, height: 450 },
                ],
            },
            {
                src: road33,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: road33, width: 800, height: 450 },
                ],
            },
        ],
    },
    {
        id: 3,
        photos: [
            {
                src: seminar1,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar1, width: 800, height: 450 },
                ],
            },
            {
                src: seminar2,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar2, width: 800, height: 450 },
                ],
            },
            {
                src: seminar3,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar3, width: 800, height: 450 },
                ],
            },
            {
                src: seminar4,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar4, width: 800, height: 450 },
                ],
            },
            {
                src: seminar5,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar5, width: 800, height: 450 },
                ],
            },
            {
                src: seminar6,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar6, width: 800, height: 450 },
                ],
            },
            {
                src: seminar7,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar7, width: 800, height: 450 },
                ],
            },
            {
                src: seminar8,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar8, width: 800, height: 450 },
                ],
            },
            {
                src: seminar9,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar9, width: 800, height: 450 },
                ],
            },
            {
                src: seminar10,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: seminar10, width: 800, height: 450 },
                ],
            },
        ],
    },
    {
        id: 4,
        photos: [
            {
                src: bisness1,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness1, width: 800, height: 450 },
                ],
            },
            {
                src: bisness2,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness2, width: 800, height: 450 },
                ],
            },
            {
                src: bisness3,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness3, width: 800, height: 450 },
                ],
            },
            {
                src: bisness4,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness4, width: 800, height: 450 },
                ],
            },
            {
                src: bisness5,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness5, width: 800, height: 450 },
                ],
            },
            {
                src: bisness6,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness6, width: 800, height: 450 },
                ],
            },
            {
                src: bisness7,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness7, width: 800, height: 450 },
                ],
            },
            {
                src: bisness8,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness8, width: 800, height: 450 },
                ],
            },
            {
                src: bisness9,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness9, width: 800, height: 450 },
                ],
            },
            {
                src: bisness10,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness10, width: 800, height: 450 },
                ],
            },
            {
                src: bisness11,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness11, width: 800, height: 450 },
                ],
            },
            {
                src: bisness12,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: bisness12, width: 800, height: 450 },
                ],
            },
            {
                src: bisness13,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: bisness13, width: 800, height: 450 },
                ],
            },
            {
                src: bisness14,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness14, width: 800, height: 450 },
                ],
            },
            {
                src: bisness15,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness15, width: 800, height: 450 },
                ],
            },
            {
                src: bisness16,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness16, width: 800, height: 450 },
                ],
            },
            {
                src: bisness17,
                width: 1600,
                height: 900,
                srcSet: [
                    { src: bisness17, width: 800, height: 450 },
                ],
            },
            {
                src: bisness18,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness18, width: 800, height: 450 },
                ],
            },
            {
                src: bisness19,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness19, width: 800, height: 450 },
                ],
            },
            {
                src: bisness20,
                width: 900,
                height: 1200,
                srcSet: [
                    { src: bisness20, width: 800, height: 450 },
                ],
            },
        ],
    }

];